import produce from 'immer'
import { assign, get, set } from 'lodash'

import { DICTIONARY_WORD_TYPES } from '../../constants'
import { FETCH_DICTIONARY_WORDS } from '../action-types'
import { DICTIONARY_WORDS_INITIAL_STATE } from '../initial-states'

const dictionaryWordsReducer = (state, action) => {
  switch (action.type) {
    case FETCH_DICTIONARY_WORDS.START:
      return produce(state, nextState =>
        assign(
          nextState,
          set(nextState, `data.${action.payload.type}`, {
            ...get(nextState, `data.${action.payload.type}`, {}),
            isLoading: true,
            error: undefined,
          }),
        ),
      )

    case FETCH_DICTIONARY_WORDS.COMPLETE:
      return produce(state, nextState =>
        assign(
          nextState,
          set(
            nextState,
            `data.${get(
              DICTIONARY_WORD_TYPES,
              `${action.payload.variables.filters.type}.fieldName`,
            )}`,
            {
              data: action.payload.data.dictionaryWords,
              isLoading: false,
              error: undefined,
            },
          ),
        ),
      )

    case FETCH_DICTIONARY_WORDS.FAIL:
      return produce(state, nextState =>
        assign(
          nextState,
          set(nextState, `data.${action.payload.type}`, {
            ...get(nextState, `data.${action.payload.type}`, {}),
            isLoading: false,
            error: action.error.message,
          }),
        ),
      )

    case FETCH_DICTIONARY_WORDS.CLEANUP:
      return { ...DICTIONARY_WORDS_INITIAL_STATE }

    default:
      return state
  }
}

export default dictionaryWordsReducer
